import { render, staticRenderFns } from "./PublishForm.vue?vue&type=template&id=409d6125&"
import script from "./PublishForm.vue?vue&type=script&lang=js&"
export * from "./PublishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports